import { Ellipsoid } from "./geodesy.ellipsoid";
export class CalculatorBase {
    constructor(e) {
        this._ellipsoid = e ?? Ellipsoid.WGS84;
    }
    get ellipsoid() {
        return this._ellipsoid;
    }
}
CalculatorBase.Shared = null;
//# sourceMappingURL=geodesy.calculators.js.map